import { useTranslation } from "react-i18next";
import oral from "../../resources/img/oral.svg";
import gastro from "../../resources/img/gastro.svg";
//import lungs from "../../resources/img/lungs.svg";
import heart from "../../resources/img/heart.svg";
import allergies from "../../resources/img/allergies.svg";
import movement from "../../resources/img/movement.svg";
import neurology from "../../resources/img/neurology.svg";
import visual from "../../resources/img/visual.svg";
import attention from "../../resources/img/attention.svg";
import pain from "../../resources/img/pain.svg";
import mood from "../../resources/img/mood.svg";
//import hiking from "../../resources/img/hiking.svg";
import urinary from "../../resources/img/urinary.svg";
import sexual from "../../resources/img/sexual.svg";
import other from "../../resources/img/other.svg";
import general from "../../resources/img/symptom.svg";
import { useContext, useEffect, useState } from "react";
import InitContext from "../pages/InitContext";
import SymptomParams from "./SymptomParams";
import Symptom from "./Symptom";
import useMmcService from "../../services/MmcService";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import {Consts} from "../pages/consts";

const convertPromsTypes = (symptoms) => {
  return symptoms?.map((symptom) => {
    let src;
    switch (symptom?.type) {
      case "cardiovascular_issues":
        src = heart;
        break;
      case "cognitive_issues":
        src = attention;
        break;
      case "gastrointestinal_tract_issues":
        src = gastro;
        break;
      case "general_health_complaints":
        src = general;
        break;
      case "issues_concerning_the_movement_apparatus":
        src = movement;
        break;
      case "mood_disorders":
        src = mood;
        break;
      case "nervous_system":
        src = neurology;
        break;
      case "oral_issues":
        src = oral;
        break;
      case "pain":
        src = pain;
        break;
      case "reproductive_organs_issues":
        src = sexual;
        break;
      case "sensory_organs_issues":
        src = visual;
        break;
      case "skin_hair_issues":
        src = allergies;
        break;
      case "urinary_tract_issues":
        src = urinary;
        break;
      case otherComplaintsKey:
        src = other;
        break;
      default:
        src = null;
    }

    return {
      src,
      type: symptom.type,
    };
  });
};

export const otherComplaintsKey = "other_health_complaints";

const SymptomModules = ({
  onSaveNewSymptoms,
  showDialog,
  hcpView,
  symptomsList,
}) => {
  const { t: t } = useTranslation();
  const [symptomParamsDialogVisible, setSymptomParamsDialogVisible] = useState(false);
  const [selectedSymptomParams, setSelectedSymptomParams] = useState("");
  const [selectedParamsDialogVisible, setSelectedParamsDialogVisible] = useState(false);
  const [allSymptoms, setAllSymptoms] = useState([]);
  const [symptomParams, setSymptomParams] = useState([]);
  const [symptomTypes, setSymptomTypes] = useState([]);
  const [selectedSymptomType, setSelectedSymptomType] = useState("");
  const context = useContext(InitContext);
  const { loading, error, clearError, getPromsJson } = useMmcService();

  useEffect(() => {
    clearError();

    getPromsJson(context?.token).then((data) => {
      setAllSymptoms(data);
      addOtherComplaints(data);
      setSymptomTypes(convertPromsTypes(data));
    });
  }, []);

  const addOtherComplaints = (data) => {
    const newSymptoms = symptomsList
      ? symptomsList?.filter((symptom) => symptom?.type === otherComplaintsKey)?.map((symptom) => ({ term: symptom?.term }))
      : [];

    const existingElement = data?.find(
      (item) => item?.type === otherComplaintsKey,
    );

    if (existingElement) {
      existingElement?.symptoms?.push(...newSymptoms);
    } else {
      data?.push({
        type: otherComplaintsKey,
        symptoms: newSymptoms,
      });
    }
  };

  const symptomTypeSelected = (type) => {
    allSymptoms?.forEach((item) => {
      if (item?.type === type) {
        setSelectedSymptomType(type);
        setSymptomParams(item?.symptoms);
        setSymptomParamsDialogVisible(true);
      }
    });
  };

  function handleSymptomParamsSelected(params) {
    if (params) {
      setSelectedSymptomParams(params);
      setSelectedParamsDialogVisible(true);
    }

    setSymptomParamsDialogVisible(false);
  }

  const errorMessage = error && (
    <ErrorMessage message={t("error_by_retrieving_all_symptoms")} />
  );

  const spinner = loading && <Spinner />;

  const findCategoryLabel = () => {
    return symptomTypes?.find((item) => {
      if (item?.type === selectedSymptomType) {
        return item;
      }
    })?.type;
  };

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-medium">
        {selectedParamsDialogVisible ? (
          <Symptom
            symptomParams={selectedSymptomParams}
            category={findCategoryLabel()}
            onUpdateSymptom={null}
            onDeleteImage={null}
            onSaveNewSymptoms={onSaveNewSymptoms}
          />
        ) : (
          <>
            {symptomParamsDialogVisible ? (
              <SymptomParams
                symptomParams={symptomParams}
                setSymptomParams={setSymptomParams}
                category={ symptomTypes?.find((item) => item?.type === selectedSymptomType)?.type }
                onSymptomParamsSelected={handleSymptomParamsSelected}
              />
            ) : (
              <>
                <header className="w3-container w3-padding-small w3-center">
                  <p>
                    {hcpView
                      ? t("please_select_a_type_of_the_symptom")
                      : t("please_select_a_type_of_your_symptom")}
                  </p>
                </header>
                {errorMessage}
                {spinner}
                <div className="w3-container form-content-scroll">
                  {!hcpView && (
                    <div className="w3-row-padding">
                      <label className="disclaimer-text">
                        {t("symptoms_disclaimer_1")}{" "}
                        {t("symptoms_disclaimer_2")}
                      </label>
                    </div>
                  )}
                  <div className="w3-row-padding w3-flex w3-flex-wrap">
                    {symptomTypes?.map((item, i) => (
                      <div
                        className="w3-display-container w3-panel w3-card-4 w3-center symptom-panel w3-col l3 m6 s12 w3-margin"
                        key={`item ${i}`}
                        onClick={() => symptomTypeSelected(item?.type)}
                      >
                        <label className="home-text">{t(item?.type)}</label>
                        <img
                          src={item?.src}
                          alt={t(item?.label)}
                          className="w3-display-bottommiddle home-icon"
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <footer className="w3-container">
                  <div className="w3-right">
                    <button
                      onClick={() => onSaveNewSymptoms(null)}
                      className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
                      type="text"
                    >
                      {t("cancel")}
                    </button>
                  </div>
                </footer>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SymptomModules;
